(() => {
  document.querySelectorAll('[data-cp-mobile-menu]').forEach(menu => {
    menu.addEventListener('click', event => {
      if (event.target.closest('a')) menu.open = false;
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });
  document.querySelectorAll('[data-cp-language]').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });
  const storyElements = [...document.querySelectorAll('[data-journey-story]')];
  if (!storyElements.length) return;
  const stories = storyElements.map(story => {
    const warehouse = story.dataset.storyKind === 'wholesale';
    const scene = story.querySelector('.cj-story-model');
    const layerAttribute = warehouse ? 'data-warehouse-layer' : 'data-layer';
    return {
      story,
      warehouse,
      chapters: [...story.querySelectorAll('[data-chapter]')],
      count: story.querySelector('.cj-stage-count'),
      progressLine: story.querySelector('.cj-progress i'),
      layers: Object.fromEntries([...scene.querySelectorAll('[' + layerAttribute + ']')].map(element => [element.getAttribute(layerAttribute), element])),
      bounds: [],
      activeChapter: -1
    };
  });
  const toggles = [...document.querySelectorAll('[data-motion-toggle]')];
  const panels = [...document.querySelectorAll('[data-scroll-panel]')];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  let queued = false;
  let panelBounds = [];
  let scrollRange = 1;
  const clamp = value => Math.max(0, Math.min(1, value));
  const ramp = (value, from, to) => clamp((value - from) / (to - from));
  const smooth = value => value * value * (3 - 2 * value);
  function paintLayer(entry, name, opacity, x = 0, y = 0, scale = 1) {
    const layer = entry.layers[name];
    if (!layer) return;
    layer.style.opacity = String(opacity);
    layer.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
  }
  function renderRetail(entry, value) {
    const open = smooth(ramp(value, .04, .28));
    const digital = smooth(ramp(value, .2, .46));
    const catalog = smooth(ramp(value, .35, .57));
    const checkout = smooth(ramp(value, .49, .72));
    const operations = smooth(ramp(value, .66, .88));
    const launch = smooth(ramp(value, .88, 1));
    paintLayer(entry, 'floor', 1 - digital * .78, 0, open * 75, 1 - digital * .06);
    paintLayer(entry, 'walls', 1 - digital, -open * 75, -open * 75);
    paintLayer(entry, 'sign', 1 - digital * .9, -open * 20, -open * 130);
    paintLayer(entry, 'shelves', 1 - digital, open * 75, -open * 30);
    paintLayer(entry, 'products', 1 - digital, open * 30, -open * 15);
    paintLayer(entry, 'browser', digital, 0, (1 - digital) * 70 - launch * 12, .9 + digital * .1);
    paintLayer(entry, 'catalog', catalog, 0, (1 - catalog) * 50 - launch * 12);
    paintLayer(entry, 'checkout', checkout, (1 - checkout) * 80, -launch * 12);
    paintLayer(entry, 'operations', operations, 0, (1 - operations) * 55 - launch * 12);
  }
  function renderWarehouse(entry, value) {
    const open = smooth(ramp(value, .02, .22));
    const portal = smooth(ramp(value, .08, .27));
    const order = smooth(ramp(value, .26, .46));
    const picking = smooth(ramp(value, .52, .8));
    const dispatch = smooth(ramp(value, .78, 1));
    paintLayer(entry, 'floor', 1, 0, portal * 18, 1 - portal * .035);
    paintLayer(entry, 'shell', 1 - portal * .82, -open * 24, -open * 15);
    paintLayer(entry, 'roof', 1 - portal, -open * 70, -open * 130);
    paintLayer(entry, 'racks', 1, -portal * 32, portal * 12);
    paintLayer(entry, 'stock', 1 - picking * .15, -portal * 32, portal * 12);
    paintLayer(entry, 'portal', portal, (1 - portal) * 80, (1 - portal) * 45);
    paintLayer(entry, 'order', order, (1 - order) * 55, 0);
    paintLayer(entry, 'picking', picking, 0, (1 - picking) * 45);
    paintLayer(entry, 'dispatch', dispatch, (1 - dispatch) * 140, 0);
  }
  function render(entry, value) {
    if (entry.warehouse) renderWarehouse(entry, value);
    else renderRetail(entry, value);
    const index = Math.min(entry.chapters.length - 1, Math.round(value * (entry.chapters.length - 1)));
    if (index !== entry.activeChapter) {
      entry.activeChapter = index;
      entry.count.innerHTML = `${String(index + 1).padStart(2, '0')} <span>/ ${String(entry.chapters.length).padStart(2, '0')}</span>`;
      entry.chapters.forEach((chapter, n) => chapter.classList.toggle('is-current', n === index));
    }
    entry.progressLine.style.transform = `scaleX(${value})`;
  }
  function measure() {
    stories.forEach(entry => {
      entry.bounds = entry.chapters.map(chapter => {
        const rect = chapter.getBoundingClientRect();
        return rect.top + window.scrollY + rect.height / 2;
      });
    });
    panelBounds = panels.map(panel => {
      const art = panel.querySelector('.cj-panel-scene') || panel;
      const rect = art.getBoundingClientRect();
      return { top: rect.top + window.scrollY, height: rect.height };
    });
    scrollRange = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  }
  function update() {
    queued = false;
    if (paused) return;
    const y = window.scrollY;
    const height = window.innerHeight;
    const focus = y + height * (window.innerWidth <= 760 ? .72 : .54);
    stories.forEach(entry => {
      const bounds = entry.bounds;
      const index = bounds.findIndex(center => center > focus);
      let value = 0;
      if (index < 0) value = 1;
      else if (index > 0) {
        const fraction = clamp((focus - bounds[index - 1]) / Math.max(1, bounds[index] - bounds[index - 1]));
        value = (index - 1 + fraction) / (entry.chapters.length - 1);
      }
      render(entry, value);
    });
    panels.forEach((panel, index) => {
      const bound = panelBounds[index];
      const progress = clamp((y + height * .88 - bound.top) / (bound.height + height * .36));
      panel.style.setProperty('--panel-progress', progress.toFixed(4));
    });
    document.body.style.setProperty('--page-progress', String(clamp(y / scrollRange)));
  }
  function requestUpdate() {
    if (!queued && !paused) {
      queued = true;
      window.requestAnimationFrame(update);
    }
  }
  function setMotion(off) {
    paused = off;
    document.body.dataset.motion = reduced.matches ? 'off' : off ? 'paused' : 'on';
    toggles.forEach(toggle => {
      toggle.setAttribute('aria-pressed', String(off));
      toggle.replaceChildren(document.createTextNode(off ? toggle.dataset.resume : toggle.dataset.pause));
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = off ? '▷' : 'Ⅱ';
      toggle.append(icon);
    });
    measure();
    if (reduced.matches) {
      stories.forEach(entry => render(entry, 1));
      panels.forEach(panel => panel.style.setProperty('--panel-progress', '1'));
    } else if (!off) requestUpdate();
  }
  stories.forEach(entry => entry.story.classList.add('is-enhanced'));
  panels.forEach(panel => panel.classList.add('is-scroll-enhanced'));
  toggles.forEach(toggle => toggle.addEventListener('click', () => setMotion(!paused)));
  reduced.addEventListener('change', event => setMotion(event.matches));
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', () => { measure(); requestUpdate(); }, { passive: true });
  window.addEventListener('pageshow', () => { measure(); requestUpdate(); });
  if (document.fonts) document.fonts.ready.then(() => { measure(); requestUpdate(); });
  setMotion(paused);
})();
